import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.date.to-string.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff, toDecimal, getPowerDownDateDiff, timestampToTime, formatDate } from "../unit/public";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
export default {
  name: "Login",
  props: ["isHaveKeychain", "isShowModelTrade", "price", "quantity", "amount", "tradeType"],
  emits: ["update:isShowModel"],
  data: function data() {
    return {
      isUseSteemKeychain: false,
      acitveKey: "",
      isLogin: false,
      isLoginError: false,
      errorMessage: "",
      rememberMe: false,
      loginResult: null,
      isLogining: false,
      loading: null,
      showLoginModel: false,
      fromUser: "",
      loginData: null
    };
  },
  watch: {
    isShowModelTrade: function isShowModelTrade(newVal) {
      this.showLoginModel = newVal;
    },
    showLoginModel: function showLoginModel(newVal) {
      this.$emit("update:isShowModelTrade", newVal);
    }
  },
  methods: {
    comfirmTrade: function comfirmTrade() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, myAccount, currentDate, orderid, expiration, amount_to_sell, min_to_receive, op, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.acitveKey) {
                  _context.next = 4;
                  break;
                }

                _this.errorMessage = "activeKeyError";
                _this.isLoginError = true;
                return _context.abrupt("return");

              case 4:
                _this.isLogining = true;
                that = _this;
                myAccount = _this.loginData[0];
                currentDate = new Date(); // Get the current date

                currentDate = new Date();
                orderid = getDateTimeStamp(formatDate(currentDate, "yyyy-MM-dd hh:mm:ss"));
                currentDate.setDate(currentDate.getDate() + 27);
                expiration = formatDate(currentDate, "yyyy-MM-ddThh:mm:ss");
                amount_to_sell = _this.tradeType === "buy" ? toDecimal(_this.amount, 3) + " SBD" : toDecimal(_this.quantity, 3) + " STEEM";
                min_to_receive = _this.tradeType === "buy" ? toDecimal(_this.quantity, 3) + " STEEM" : toDecimal(_this.amount, 3) + " SBD";
                op = ["limit_order_create", {
                  owner: myAccount,
                  orderid: orderid,
                  amount_to_sell: amount_to_sell,
                  min_to_receive: min_to_receive,
                  fill_or_kill: false,
                  expiration: expiration
                }];
                _context.prev = 15;
                _context.next = 18;
                return dsteem.sendOperations([op], _this.acitveKey);

              case 18:
                result = _context.sent;

                if (result && result.block_num) {
                  _this.isLoginError = false;
                  _this.errorMessage = "";
                  _this.isLogining = false;

                  _this.$emit("comfirmTrade");
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                }

                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](15);

                if (_context.t0.jse_info.code == 10) {
                  _this.isLoginError = true;
                  _this.errorMessage = "balanceError";
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                } //


              case 25:
                _this.isLogining = false;

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[15, 22]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loginData = extractLoginData();

              if (_this2.loginData) {
                _this2.fromUser = _this2.loginData[0];
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};